import { useEffect, useState, type CSSProperties } from 'react';

interface Piece {
  id: number;
  left: number;
  cx: number;
  cy: number;
  cr: number;
  delay: number;
  dur: number;
  color: string;
}

const COLORS = ['var(--vine)', 'var(--vine-bright)', 'var(--seed)', 'var(--berry)', 'var(--sky)'];

/** A short burst of leaves/seeds. Bumping `trigger` (a counter) replays it. */
export function Celebration({ trigger }: { trigger: number }) {
  const [pieces, setPieces] = useState<Piece[]>([]);

  useEffect(() => {
    if (trigger <= 0) return;
    const count = 30;
    const next: Piece[] = Array.from({ length: count }, (_, i) => ({
      id: trigger * 1000 + i,
      left: 50 + (Math.random() * 56 - 28),
      cx: Math.random() * 220 - 110,
      cy: 150 + Math.random() * 130,
      cr: Math.random() * 360 - 180,
      delay: Math.random() * 180,
      dur: 1000 + Math.random() * 700,
      color: COLORS[i % COLORS.length],
    }));
    setPieces(next);
    const t = window.setTimeout(() => setPieces([]), 2200);
    return () => window.clearTimeout(t);
  }, [trigger]);

  if (pieces.length === 0) return null;

  return (
    <div className="cv-celebration" aria-hidden="true">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="cv-confetti"
          style={
            {
              left: `${p.left}%`,
              background: p.color,
              '--cx': `${p.cx}px`,
              '--cy': `${p.cy}px`,
              '--cr': `${p.cr}deg`,
              '--cd': `${p.dur}ms`,
              '--cdelay': `${p.delay}ms`,
            } as CSSProperties
          }
        />
      ))}
    </div>
  );
}
